module.exports = __webpack_public_path__ + "media/src/images/page02_zu_worksheet-11d7c0041bb349fa266c23e722230b9c.gif";